"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- LOGO : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'Logo',
  group: _definitionhelpers.groupNames.graphics,
  props: {
    name: {
      type: 'string',
      default: 'insticator',
      options: ['insticator', 'insticator-icon']
    },
    text: {
      type: 'string',
      default: 'Insticator',
      options: ['Insticator']
    }
  }
};
exports.default = _default;